import styled from 'styled-components';
import colors from 'styles/colors';
import { BrandCode } from 'types';

export const Container = styled.div`
	position: relative;
	margin-right: 0;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
            font-family: ${theme.typography.fontFamilySemiBold};
            font-size: 12px;
            line-height: 14.4px;
        `,
			[BrandCode.RoyalCaribbean]: `
            font-family: ${theme.typography.fontFamilySemiBold};
            font-size: 12px;
            line-height: 14.4px;
            letter-spacing: -0.12px;
        `,
		})[theme.brandCode]}
`;

export const PreLabel = styled.span`
	color: ${colors.functional.darkGrey};
	font-style: italic;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
            font-family: ${theme.typography.fontFamily};
            font-weight: 400;
          
        `,
			[BrandCode.RoyalCaribbean]: `
            font-family: ${theme.typography.fontFamily};
            font-weight: 400;
          
        `,
		})[theme.brandCode]}
`;

export const LabelContent = styled.span`
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `            
            font-weight: 700;
            color: ${colors.celebrity.blue};
          
        `,
			[BrandCode.RoyalCaribbean]: `            
            font-weight: 700;
            color: ${colors.secondary.deepCove};
          
        `,
		})[theme.brandCode]}
`;
